if (!window._breezeAddToCart) {
    window._breezeAddToCart = true;

    const quickAddToCartSelectorsArray = ["[data-breeze-add-to-cart]"];
    const quickAddToCartSelector = quickAddToCartSelectorsArray.join(',');
    const cartDrawerSelector = '#cart-counter';
    const cartDrawerButton = document.querySelector(cartDrawerSelector);

    function handleQuickAddToCart(event) {
        if (event.target.closest(quickAddToCartSelector)) {
            console.log("quick add to cart");
            setTimeout(() => {
                if (cartDrawerButton) {
                    cartDrawerButton.click();
                    console.log("cart drawer opened");
                }
            }, 800);
        }
    }

    document.addEventListener('click', handleQuickAddToCart);
}